import DashboardFinance from './routes/dashboard/Dashboard.vue';
import detailTransaction from './routes/dashboard/component/detailTransaction.vue';

import TransactionLog from './routes/transaction_log/TransactionLog.vue';
import detailTransactionLog from './routes/transaction_log/component/detailTransaction.vue';

import PaymentInstruction from './routes/payment_instruction/PaymentInstruction.vue';
import editPaymentInstruction from './routes/payment_instruction/component/editPaymentInstruction.vue';

import PaymentMethod from './routes/payment_method/PaymentMethod.vue';

import createPaymentMethod from './routes/payment_method/component/createPaymentMethod.vue';
import editPaymentMethod from './routes/payment_method/component/editPaymentMethod.vue';

import createProductLocation from './routes/payment_method/component/createProductLocation.vue';
import editProductLocation from './routes/payment_method/component/editProductLocation.vue';

const FinanceRoutes = [
  {
    path: '/edit-payment-instruction/:id/:product',
    name: 'editPaymentInstruction',
    component: editPaymentInstruction,
    props: true
  },
  {
    path: '/payment-instruction',
    name: 'PaymentInstruction',
    component: PaymentInstruction,
  },
  {
    path: '/detail-transaction-log/:id',
    name: 'detailTransactionLog',
    component: detailTransactionLog,
  },
  {
    path: '/transaction-log',
    name: 'TransactionLog',
    component: TransactionLog,
  },
  {
    path: '/detail-transaction/:id',
    name: 'detailTransaction',
    component: detailTransaction,
  },
  {
    path: '/dashboard-finance',
    name: 'DashboardFinance',
    component: DashboardFinance,
  },
  {
    path: '/payment-method',
    name: 'PaymentMethod',
    component: PaymentMethod,
  },
  {
    path: '/create-payment-method',
    name: 'createPaymentMethod',
    component: createPaymentMethod,
  },
  {
    path: '/edit-payment-method/:id',
    name: 'editPaymentMethod',
    component: editPaymentMethod,
  },
  {
    path: '/create-product-location',
    name: 'createProductLocation',
    component: createProductLocation,
  },
  {
    path: '/edit-product-location/:id',
    name: 'editProductLocation',
    component: editProductLocation,
  },


];

export default FinanceRoutes;
